import React from 'react'
import NumberFormat from 'react-number-format'
import { getCreditCardName, getCreditCardRelationship } from '../../helpers/texthelper'
import { DocumentDetailModel } from '../../models/documentDetail'
import ReceiptList from '../ReceiptList/ReceiptList'

export const CreditCardDetail: React.FC<{ item: DocumentDetailModel }> = ({ item }) => {
  const displayCreditCard = (creditCardNumber: string, creditCardNumberRaw: string) => {
    return creditCardNumber
  }
  const displayCreditCardExpireDateFormat = () => {
    //if (loginState.account?.agentInfo.isAO || loginState.account?.agentInfo.isBranchStaff)
    return '##/##'

    //return '#X/YY'
  }
  return (
    <>
      <div className="flex-container">
        <div className="flex-item-left">
          <div className="flex-container-cc">
            <div className="flex-item-cc-left">
              <li>
                <span>{item.paymentMethod.name}</span>{' '}
              </li>
            </div>
          </div>
          <div className="flex-container-cc-detail">
            <div className="flex-item-detail-left">
              เลขที่ :{' '}
              <span>
                {displayCreditCard(item.creditCard_Number, item.creditCard_Number_data as string)}
              </span>
            </div>
            <div className="flex-item-detail-right">
              ประเภท : <span>{getCreditCardName(item.creditCard_Type)}</span>
            </div>
            <div className="flex-item-detail-left">
              วันหมดอายุ :{' '}
              <span>
                <NumberFormat
                  value={item.creditCard_ExpDate}
                  prefix=""
                  format={displayCreditCardExpireDateFormat()}
                  displayType="text"
                  type="text"
                />
              </span>
            </div>
            <div className="flex-item-detail-right">
              ชื่อเจ้าของบัตร : <span>{item.creditCard_HolderName}</span>
            </div>
            <div className="flex-item-detail-left">
              เจ้าของบัตรเครดิตมีความสัมพันธ์เป็นอะไรกับผู้เอาประกันภัย :{' '}
              <span>{getCreditCardRelationship(item.creditCard_HolderRelationship)}</span>
            </div>
          </div>
        </div>
        <div className="flex-item-right amount-right">
          <span>
            <NumberFormat
              thousandsGroupStyle="thousand"
              value={item.paymentAmount}
              prefix=""
              decimalSeparator="."
              displayType="text"
              type="text"
              thousandSeparator={true}
              allowNegative={true}
              decimalScale={2}
              fixedDecimalScale={true}
            />
          </span>{' '}
          บาท
        </div>
      </div>
      {/* <ReceiptList documentDetail={item} />
      <hr className="separate-detail"></hr> */}
    </>
  )
}
